import { getStreetList, getStreetDetail, getParkingList, getOilList, getNewEnergyList, getWcList } from "@/services/http";

export const DATA_TYPE_STREET = 'street';
export const DATA_TYPE_PARKING = 'parking';
export const DATA_TYPE_OIL = 'oil';
export const DATA_TYPE_NEWENERGY = 'newEnergy';
export const DATA_TYPE_WC = 'wc';


export const DATA_TYPE_CONFIG = {
    [DATA_TYPE_STREET]: {
        alias: '路边停车',
        showOnMarker: true,
        // refreshData: true,
        getList: getStreetList,
        getDetail: getStreetDetail,
    },
    [DATA_TYPE_PARKING]: {
        alias: '停车场',
        showOnMarker: false,
        // refreshData: false,
        getList: getParkingList,
        getDetail: null,

    },
    [DATA_TYPE_OIL]: {
        alias: '加油站',
        showOnMarker: false,
        // refreshData: false,
        getList: getOilList,
        getDetail: null,
    },
    [DATA_TYPE_NEWENERGY]: {
        alias: '新能源',
        showOnMarker: false,
        // refreshData: false,
        getList: getNewEnergyList,
        getDetail: null,
    },
    [DATA_TYPE_WC]: {
        alias: '建宁驿站',
        showOnMarker: false,
        // refreshData: false,
        getList: getWcList,
        getDetail: null,
    },
};